import {css, StyleSheet} from "aphrodite";
import * as React from "react";

import Button from "@khanacademy/wonder-blocks-button";
import {View} from "@khanacademy/wonder-blocks-core";
import {mediaQueries} from "@khan/shared-styles";
import {staticUrl} from "@khan/urls";

// eslint-disable-next-line no-restricted-imports -- TODO: Replace this component with the equivalent one from Wonder Blocks.
import DeprecatedStrut from "#components/layout-package/deprecated-strut.tsx";
import {SerifHeadingMedium} from "#marketing-content-shared-package/typography/typography.ts";

type Cta = {
    kind: "link";
    copy: string;
    href: string;
};

type Props = {
    headline: string;
    ctas: Array<Cta>;
    backgroundUrl: string;
};

export default class LastChance extends React.Component<Props> {
    render(): React.ReactNode {
        const {headline, ctas, backgroundUrl} = this.props;

        return (
            <View>
                <View style={styles.container}>
                    <View style={styles.background}>
                        <img
                            alt=""
                            className={css(styles.img)}
                            src={staticUrl(backgroundUrl)}
                        />
                    </View>

                    <View style={styles.foreground}>
                        <SerifHeadingMedium tag="h2" style={styles.heading}>
                            {headline}
                        </SerifHeadingMedium>

                        <DeprecatedStrut size={50} />

                        {ctas.map((cta, i) => {
                            if (cta.kind === "link") {
                                return (
                                    <Button
                                        key={i}
                                        size="large"
                                        href={cta.href}
                                        style={styles.button}
                                    >
                                        {cta.copy}
                                    </Button>
                                );
                            }
                        })}
                    </View>
                </View>
                {/* Spacing between this and the footer */}
                <DeprecatedStrut size={250} />
            </View>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        flexDirection: "column",
        justifyContent: "flex-end",
    },
    background: {
        position: "relative",
        zIndex: 0,

        [mediaQueries.smOrSmaller]: {
            // On mobile, things change, and our image no longer runs through
            // the button.
            // Because the background is our relative layer, we have to
            // increase its height so that it encompasses the stuff in the
            // foreground.
            paddingBottom: 100,
        },
    },
    img: {
        width: "100%",
        maxWidth: 782,
        height: "auto",
        maxHeight: 415,
        margin: "auto",
    },
    foreground: {
        // NOTE: normally, the background layer is positioned absolutely.
        // In this component, the background is relative while the foreground
        // is absolute.
        // This was done to make it easier to align the background with an
        // element in the CTA. On all tablet and desktop sizes, the strands
        // flow through the button.
        position: "absolute",
        zIndex: 1,
        left: 0,
        right: 0,
        bottom: "10%",
        alignItems: "center",
        textAlign: "center",

        [mediaQueries.smOrSmaller]: {
            // On mobile, our foreground sits a bit below the background image,
            // so nudge it down from the top instead of aligning to the bottom.
            bottom: "initial",
            top: "23vw",
        },
    },
    heading: {
        maxWidth: 700,
        margin: "auto",

        [mediaQueries.md]: {
            maxWidth: 550,
        },

        [mediaQueries.smOrSmaller]: {
            maxWidth: 440,
            paddingLeft: 20,
            paddingRight: 20,
        },
    },
    button: {
        minWidth: 350,
        // On smaller screen sizes, fill the viewport except for 20px padding
        // on each side.
        maxWidth: "calc(100% - 20px - 20px)",
        marginBottom: 8,
    },
});
